import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListInventories(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getArrivalDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
})()